import { Theme } from '@livecontrol/core-ui';
import { Phone } from '@livecontrol/locale-us';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';
import type { Maybe } from '../../../../graphql-types';
// eslint-disable-next-line import/no-internal-modules
import type { ContactRole } from '../../graphql/__generated__/use-scheduled-event';

import G = Matrix.Grid;
import H = G.Header;
import C = G.Row.Cell;

interface Props {
  contacts: Maybe<ContactRole>[];
}

export const TroubleshootingGrid = ({ contacts }: Props): React.ReactElement => {
  const viewport = Theme.useViewport();

  return (
    <G viewport={viewport} gridTemplateColumns='fit-content(10%) repeat(4, 1fr) fit-content(40%)'>
      {/* Header */}
      <G.Row>
        <H viewport={viewport}>Priority</H>
        <H viewport={viewport}>Name</H>
        <H viewport={viewport}>Email</H>
        <H viewport={viewport}>Phone Number</H>
        <H viewport={viewport}>Preference</H>
        <H viewport={viewport}>Notes</H>
      </G.Row>

      {
        /* Content */
        contacts
          .filter((v): v is NonNullable<typeof v> => !!v)
          .map(
            (contact): React.ReactElement => (
              <G.Row key={contact.user?.id}>
                <C>{contact.onsite_technical_priority}</C>
                <C>{contact.user?.first_name}</C>
                <C>{contact.user?.email}</C>
                <C>
                  {Phone.normalize(contact.user?.phone_number)?.format({ parenthetical: true }) ??
                    contact.user?.phone_number}
                </C>
                <C>{contact.user?.preferred_contact_method}</C>
                <C>{contact.user?.additional_information}</C>
              </G.Row>
            )
          )
      }
    </G>
  );
};
